import dayjs from "dayjs";
import { Component, ReactNode } from "react";
import { DatePicker } from "rsuite";

interface IDatePickerProps {
  onChange: (value: any) => void;
  value: Date | undefined;
  readonly?: boolean;
}

interface IDatePickerState {
  value: Date | undefined;
}

export class DatePickerComponent extends Component<
  IDatePickerProps,
  IDatePickerState
> {
  state = {
    value:
      this.props.value && typeof this.props.value === "string"
        ? new Date(this.props.value)
        : undefined,
  };

  handleOnChange = (value: Date | null) => {
    if (value) {
      const formattedDate = dayjs(value).format("YYYY-MM-DD HH:mm:ss.SSS");
      this.props.onChange?.(formattedDate);
      this.setState({ value });
    } else {
      this.props.onChange?.(null);
      this.setState({ value: undefined });
    }
  };

  render(): ReactNode {
    return (
      <DatePicker
        format="dd/MM/yyyy"
        value={this.state.value}
        onChange={this.handleOnChange}
        onClean={() => this.props.onChange(null)}
        disabled={this.props.readonly}
        oneTap
        style={{
          display: "flex",
        }}
        placeholder="DD/MM/YYYY"
      />
    );
  }
}
